import React, { useState, useEffect } from "react";
import Container from "../../components/layout/Container/Container";
import { getHarvestDetailsRFA } from "../../api/apimethods";
import { IHarvestDetailsRFAResponseModel } from "../../typings/models/HarvestDetailsRFAResponseModel";
import HarvestDetailsRFAGrid from "./HarvestDetailsRFAGrid";
import { useLocation } from "react-router-dom";

interface ChildProps {
  RfaData: (category: string, status: string) => void;
  //   RfaCategory: (data: string) => void;
  //   RfaStatus: (data: string) => void;
}

const HarvestDetailsDashboard: React.FC<ChildProps> = ({ RfaData }) => {
  const [data, setData] = useState<IHarvestDetailsRFAResponseModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [displayGrid, setDisplayGrid] = useState(false);
  const [rfaCategory, setRfaCategory] = useState("3");
  const location = useLocation();
  let harvestDetailsId = location.state?.id;

  // Fetch data from API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (harvestDetailsId != undefined) {
          const response = await getHarvestDetailsRFA(harvestDetailsId);
          if (response.data && response.data.length > 0) {
            let data = response.data.sort(
              (a, b) => b.createdDate - a.createdDate
            );
            let data1 = response.data.sort((a, b) =>
              b.createdDate.localeCompare(a.createdDate)
            );
            RfaData(data[0].rfaCategory, data[0].rfaStatus);
            // RfaStatus(data[0].rfaStatus);
            setDisplayGrid(true);
            setData(response.data);
            setIsLoading(false);
          } else {
            RfaData("", "");
            setData([]);
          }
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching harvest applications rfa:", error);
      }
    };

    fetchData();
  }, [harvestDetailsId, RfaData]);

  return (
    <>
      {/* <Header /> */}
      <Container>
        {/* <Banner name="DragonFish all schedule tasks" uiClass="banner-bg" /> */}
        {/* <h3>My all tasks</h3> */}
        {displayGrid && (
          <div>
            <h1 className="csp-color-02763A">Harvest Details RFA</h1>
            <HarvestDetailsRFAGrid data={data} isLoading={isLoading} />
          </div>
        )}
      </Container>
    </>
  );
};

export default HarvestDetailsDashboard;
